export default __webpack_public_path__ + "static/media/house2.e76204f3.png";